<template>
  <tree-selector
    :mutiple="mutiple"
    :mutiValue="mutiValue"
    :treeData="areaTree"
    @muti-delete="mutiDelete"
    @muti-input="mutiInput"
    @on-clear="clear"
    :maskType="true"
    v-model="selected"
  >
    <div slot="title" class="title">
      请选择地区
    </div>
  </tree-selector>
</template>

<script>
import treeSelector from '@/components/tree-selector'

export default {
  name: 'area-selector',
  components: {
    treeSelector
  },
  props: {
    value: {
      type: [Number, String],
      required: false
    },
    mutiValue: {
      type: [Array, String],
      required: false
    },
    mutiple: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      selected: ''
    }
  },
  computed: {
    areaTree () {
      return this.$store.getters['common/areaTree']
    },
    areaData () {
      return this.$store.getters['common/areaData']
    }
  },
  watch: {
    value () {
      this.makeSelected()
    },
    selected () {
      if (!this.selected || !this.areaData[this.selected]) {
        this.$emit('on-clear')
      } else {
        this.$emit('on-select', this.areaData[this.selected])
      }
    }
  },
  created () {
    console.log('muti:', typeof (this.mutiValue))
    this.$store.dispatch('common/getAllArea').then(res => {
      res && this.makeSelected()
    })
  },
  methods: {
    mutiInput (data) {
      this.$emit('muti-input', data)
    },
    mutiDelete (index) {
      this.$emit('muti-delete', index)
    },
    makeSelected () {
      this.selected = this.value
    },
    clear () {
      this.$emit('on-clear')
    }
  }
}
</script>

<style lang="stylus" scoped>
.title
  font-size 0.24rem
</style>
